import styled from 'styled-components'

import { ButtonWithLabelUnstyled } from 'Components/Buttons/ButtonWithLabel/unstyled'

export const ButtonWithLabel = styled(ButtonWithLabelUnstyled)`
  display: block;
  float: left;
  height: 50px;
  padding: 0 35px;
  line-height: 50px;
  background: ${props =>
    props.fill ||
    (props.disabled
      ? props.theme.colors.athensGray2
      : props.theme.colors.primary)};
  color: ${props => props.theme.colors.oxfordBlue};
  border-radius: 4px;
  font-size: ${props => props.theme.fontSizes.modal.modalButton};
  font-family: ${props => props.theme.fonts.robotoMedium};
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  position: relative;
  margin-right: 10px;

  svg {
    position: absolute;
    height: 100%;
    width: 14px;
    fill: ${props => props.theme.colors.white};
    left: 30px;
    margin: auto;
  }

  label {
    color: ${props => props.theme.colors.white};
    margin-bottom: 0;
    padding-left: 20px;
    cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  }
`
